class ModulesLoader {
    constructor(modules) {
        this.modules = modules;
    }

    static injectModules (modules) {
        const moduleElements = document.querySelectorAll('[data-js-module]:not([data-js-module-initialised]');

        if (moduleElements.length > 0) {
            moduleElements.forEach(moduleElement => {
                const moduleName = moduleElement.dataset.jsModule;

                if (typeof modules[moduleName] !== 'undefined') {
                    const module = new modules[moduleName](moduleElement);
                    module.init();
                    moduleElement.setAttribute('data-js-module-initialised', 'true');
                }
            });
        }
    };

    init() {
        this.constructor.injectModules(this.modules);
    }
}

export default ModulesLoader;
